(function() { window.GUID_459d2620_9f89_4784_891c_21ed1dfc2a0e = { getGuid: function() { return "459d2620-9f89-4784-891c-21ed1dfc2a0e"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    class FilteredSection {
                        get filtersAreCollapsed() {
                            const instance = this;
                            return instance._filtersAreCollapsed;
                        }
                        get isWallLayout() {
                            return true;
                        }
                        get filtersCount() {
                            return 0;
                            //return $("#GamesV2ActiveFilters").val();
                        }
                        get accordionChildSelector() {
                            return "";
                            //return "#filters-games";
                        }
                        onFilterChanged(url) { }
                        onBeforeUIRefresh() { }
                        constructor() {
                            this._filtersAreCollapsed = true;
                            this._observers = [];
                        }
                        setObservers(accordion) {
                            const instance = this;
                            instance.clearObservers();
                            const $filters = accordion.$Content.find(".filters");
                            const $toolbar = accordion.$Content.find(".toolbar");
                            if ($filters.length && $toolbar.length) {
                                const $topbar = $("#section-top");
                                const $bottomBar = $("#section-bottom");
                                const $subTopbar = $("#section-sub-top");
                                let topHeight = $topbar.outerHeight();
                                if ($subTopbar.length)
                                    topHeight += $subTopbar.outerHeight();
                                const bottomHeight = $bottomBar.outerHeight();
                                $topbar.addClass("no-box-shadow");
                                $topbar.addClass("with-border-bottom");
                                instance._observers.push(new CS.Helper.CSIntersectionObserver($filters, topHeight, bottomHeight), new CS.Helper.CSIntersectionObserver($toolbar, topHeight, bottomHeight));
                                const onFiltersVisible = () => {
                                    $topbar.addClass("no-box-shadow");
                                    $topbar.addClass("with-border-bottom");
                                };
                                const onFiltersPartiallyHidden = () => {
                                    $topbar.addClass("no-box-shadow");
                                    $topbar.addClass("with-border-bottom");
                                };
                                const onFiltersHidden = () => {
                                    $topbar.removeClass("no-box-shadow");
                                    $topbar.removeClass("with-border-bottom");
                                };
                                instance._observers[0].observeTopIntersections(`${accordion.ControlId}-filters`, onFiltersVisible, onFiltersPartiallyHidden, onFiltersHidden);
                                let toolbarWasVisible = true;
                                const $chips = accordion.$Content.find(".chips");
                                $chips.css({
                                    top: `${Math.floor(topHeight) - 1}px`,
                                });
                                $chips.removeClass("hiddenforced");
                                const onToolbarVisible = () => {
                                    //$chips.addClass("hiddenforced");
                                    //$chips.addClass("xyz-out");
                                    //$chips.removeClass("xyz-in");
                                    toolbarWasVisible = true;
                                };
                                const onToolbarPartiallyHidden = (hiddenRatio, invertedHiddenRatio) => {
                                    if (toolbarWasVisible) {
                                        //$chips.addClass("hiddenforced");
                                        //$chips.addClass("xyz-out");
                                        //$chips.removeClass("xyz-in");
                                    }
                                };
                                const onToolbarHidden = () => {
                                    //$chips.removeClass("hiddenforced");
                                    //$chips.removeClass("xyz-out");
                                    //$chips.addClass("xyz-in");
                                    toolbarWasVisible = false;
                                };
                                instance._observers[1].observeTopIntersections(`${accordion.ControlId}-chips`, onToolbarVisible, onToolbarPartiallyHidden, onToolbarHidden);
                                // Default state avant qu'on commence à scroller
                                $topbar.addClass("no-box-shadow");
                                $topbar.addClass("with-border-bottom");
                                //$chips.addClass("hiddenforced");
                                //$chips.addClass("xyz-out");
                                //$chips.removeClass("xyz-in");
                            }
                        }
                        clearObservers() {
                            const instance = this;
                            const { _observers } = instance;
                            if (_observers != null && _observers.length > 0) {
                                for (const key in _observers) {
                                    if (_observers[key]) {
                                        _observers[key].stopObservingTopIntersections();
                                        _observers[key] = null;
                                    }
                                }
                            }
                            instance._observers = [];
                        }
                        updateFiltersState(state, $elementsContainer, $elementsToToggle, callback) {
                            if (state == "collapsed") {
                                $elementsToToggle.slideUp(150, () => {
                                    if (callback)
                                        callback.call(this);
                                });
                            }
                            else if (state == "expanded") {
                                $elementsToToggle.slideDown(150, () => {
                                    if (callback)
                                        callback.call(this);
                                });
                            }
                            if (state == "collapsed")
                                CS.Lag("matches-wall-toggle-filters", 75, () => $elementsContainer.addClass("collapsed"));
                            else
                                CS.Lag("matches-wall-toggle-filters", 75, () => $elementsContainer.removeClass("collapsed"));
                        }
                        toggleCustomPresetVisibility(visibilityCondition) { }
                        updateUI(accordion) {
                            this.setLazyloadingUrl(accordion);
                            const filtersCounterHtml = CS.DOM.$topBar.find(".filters").html();
                            if (this.filtersCount && filtersCounterHtml) {
                                const index = filtersCounterHtml.indexOf("(") + 1;
                                const newFiltersCounterHtml = filtersCounterHtml.substring(0, index) +
                                    this.filtersCount +
                                    filtersCounterHtml.substring(index + 1);
                                const opacity = this.filtersCount == 0 ? 0 : 1;
                                CS.DOM.$topBar
                                    .find(".filters")
                                    .html(newFiltersCounterHtml)
                                    .css({ opacity: opacity });
                            }
                            const $lazyLoadingTrigger = accordion.$Content.find(".button-lazy-loader-trigger");
                            if ($lazyLoadingTrigger.length)
                                CS.Lag(`${accordion.ControlId}-lazyload`, 500, () => $lazyLoadingTrigger.trigger("click"));
                            const $chipsVisibilityTrigger = accordion.$Content.find(".toolbar");
                            const $chips = accordion.$Content.find(".chips");
                            if ($chips.length)
                                $chips.removeClass("hiddenforced");
                            this.setObservers(accordion);
                        }
                        setLazyloadingUrl(accordion) {
                            const $lazyloadingUrl = $("#LazyloadingUrl");
                            if ($lazyloadingUrl.length)
                                accordion.Data.RefreshUrl = $lazyloadingUrl.val();
                        }
                        extractData(extraData, accordion) {
                            const { isCurrent, url: baseUrl, isDisabled, snackbarMessage, } = extraData;
                            const url = this.formatSectionUrl(baseUrl, accordion);
                            return {
                                url,
                                isCurrent,
                                isDisabled,
                                snackbarMessage,
                            };
                        }
                        formatSectionUrl(url, accordion) {
                            const collapsedStateInUrl = url.indexOf("filtersState=Collapsed") > -1;
                            const collapsedStateFits = collapsedStateInUrl == this.filtersAreCollapsed;
                            if (!collapsedStateFits) {
                                if (this.filtersAreCollapsed) {
                                    url = url.replace("filtersState=Expanded", "filtersState=Collapsed");
                                }
                                else {
                                    url = url.replace("filtersState=Collapsed", "filtersState=Expanded");
                                }
                            }
                            url += "&wallLayout=True";
                            return url;
                        }
                        removeLazyloadingTrigger(accordion) {
                            accordion.$Content.find(".button-lazy-loader-trigger").remove();
                            accordion.$Content.find(".lazy-loader-trigger").remove();
                        }
                        appendFiltersCounterInTopBar() {
                            try {
                                //const opacity = this.filtersCount == 0 ? 0 : 1;
                                //const html = `<div class="filters" style="opacity: ${opacity};">
                                //        <div class="icon ic-cs-filter" data-html=""></div>&nbsp;<span class="label">(${this.filtersCount})</span>
                                //    </div>`;
                                //const $container = DOM.$topBar.find(
                                //    ".cs-persona-picker__content .info .title"
                                //);
                                //console.log($container);
                                //$container.append(html);
                            }
                            catch (e) {
                                console.log(e);
                            }
                        }
                        registerRenderedEvents(accordion, e) {
                            const instance = this;
                            const { isWallLayout } = instance;
                            if (isWallLayout) {
                                instance.setObservers(accordion);
                                instance.appendFiltersCounterInTopBar();
                                const $chips = accordion.$Content.find(".chips");
                                if ($chips.length) {
                                    $chips.css({
                                        top: `${Math.floor($("#section-top").outerHeight()) - 1}px`,
                                    });
                                    $chips.removeClass("hiddenforced");
                                }
                            }
                        }
                        registerReadyEvents(accordion, e, filtersControlIdSuffix) {
                            var _a, _b, _c, _d;
                            const instance = this;
                            //=================================================================================//
                            //============================// Pin results to top
                            accordion.$Content.offon("click.pinResults", "#button-pin-results", (e) => {
                                const $btn = $(e.currentTarget);
                                const { pinUrl, successmsg } = $btn.data("html");
                                if (pinUrl != null) {
                                    accordion.pinSection(pinUrl, accordion, () => {
                                        if (!CS.Helper.isNullOrWhiteSpace(successmsg)) {
                                            CS.Controls.Snackbar.Show({
                                                Id: "pin-toggle-success",
                                                Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
                                                Animation: CS.Enumeration.SnackbarAnimation.Slide,
                                                Type: CS.Enumeration.SnackbarType.Success,
                                                Message: successmsg,
                                                AutoHideDuration: 3000,
                                            });
                                        }
                                    });
                                }
                            });
                            if (!this.isWallLayout) {
                                this.removeLazyloadingTrigger(accordion);
                                return;
                            }
                            let filtersUIFreezed = false;
                            //=================================================================================//
                            //============================// Filters V2
                            /*
                                    When any filter is changed, we need to update the main search bar with the value of the "Name" filter
                                  */
                            // FiltersBar
                            CS.Controls.FiltersBar.Events.ChipClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-${filtersControlIdSuffix}-${accordion.ContentId}-bar`,
                                callback: (filtersBar, e) => {
                                    CS.Helper.log("FilteredSection", "ChipClicked", e);
                                    if (filtersBar.uiFreezed)
                                        return;
                                    filtersUIFreezed = true;
                                    const url = this.formatSectionUrl(e.data.toggleUrl, accordion);
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        filtersBar.uiFreezed = false;
                                        filtersUIFreezed = false;
                                        this.updateUI(accordion);
                                        yield filtersBar.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                        instance.onFilterChanged(e.data.toggleUrl);
                                    }), url);
                                },
                            });
                            CS.Controls.FiltersBar.Events.SortItemClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-${filtersControlIdSuffix}-${accordion.ContentId}-bar`,
                                callback: (filtersBar, e) => {
                                    const url = this.formatSectionUrl(e.data.url, accordion);
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        filtersUIFreezed = false;
                                        this.updateUI(accordion);
                                        yield filtersBar.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                        instance.onFilterChanged(e.data.url);
                                    }), url);
                                },
                            });
                            // ./FiltersBar
                            // Filters
                            CS.Controls.Filters.Events.SortItemClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-drawer-${filtersControlIdSuffix}-${accordion.ContentId}-bar`,
                                callback: (filters, e) => {
                                    const url = this.formatSectionUrl(e.data.url, accordion);
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        filtersUIFreezed = false;
                                        this.updateUI(accordion);
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                        instance.onFilterChanged(e.data.url);
                                    }), url);
                                    const $parentPopup = $(`#popup-filters-drawer-filters-${filtersControlIdSuffix}-${accordion.ContentId}-bar`);
                                    const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                    if (parentPopup != null)
                                        parentPopup.Close();
                                },
                            });
                            CS.Controls.Filters.Events.FiltersToggleClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-drawer-${filtersControlIdSuffix}-${accordion.ContentId}-bar`,
                                callback: (filters, e) => __awaiter(this, void 0, void 0, function* () {
                                    if (e.data.filtersStateSerialized) {
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                        const $parentPopup = $(`#popup-filters-drawer-filters-${filtersControlIdSuffix}-${accordion.ContentId}-bar`);
                                        const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                        if (parentPopup != null)
                                            parentPopup.Close();
                                    }
                                }),
                            });
                            CS.Controls.Filters.Events.ItemClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-drawer-${filtersControlIdSuffix}-${accordion.ContentId}-bar`,
                                callback: (filters, e) => {
                                    const url = this.formatSectionUrl(e.data.url, accordion);
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        filtersUIFreezed = false;
                                        this.updateUI(accordion);
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                        instance.onFilterChanged(e.data.url);
                                    }), url);
                                    const $parentPopup = $(`#popup-filters-drawer-filters-${filtersControlIdSuffix}-${accordion.ContentId}-bar`);
                                    const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                    if (parentPopup != null)
                                        parentPopup.Close();
                                },
                            });
                            CS.Controls.Filters.Events.FilterToggleClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-drawer-${filtersControlIdSuffix}-${accordion.ContentId}-bar`,
                                callback: (filters, e) => {
                                    const url = this.formatSectionUrl(e.data.toggleUrl, accordion);
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        filtersUIFreezed = false;
                                        this.updateUI(accordion);
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                        instance.onFilterChanged(e.data.toggleUrl);
                                    }), url);
                                    const $parentPopup = $(`#popup-filters-drawer-filters-${filtersControlIdSuffix}-${accordion.ContentId}-bar`);
                                    const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                    if (parentPopup != null)
                                        parentPopup.Close();
                                },
                            });
                            CS.Controls.Filters.Events.TextChanged({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-drawer-${filtersControlIdSuffix}-${accordion.ContentId}-bar`,
                                callback: (filters, e) => {
                                    const url = this.formatSectionUrl(e.data.url, accordion);
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        filtersUIFreezed = false;
                                        this.updateUI(accordion);
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                        instance.onFilterChanged(e.data.url);
                                    }), url);
                                    const $parentPopup = $(`#popup-filters-drawer-filters-${filtersControlIdSuffix}-${accordion.ContentId}-bar`);
                                    const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                    if (parentPopup != null)
                                        parentPopup.Close();
                                },
                            });
                            // ./Filters
                            //============================// ./Filters V2
                            //=================================================================================//
                            const $filtersBar = $(".accordion-events-filtered .filters-bar");
                            if ($filtersBar.length && ((_a = CS.DOM.$subTop) === null || _a === void 0 ? void 0 : _a.length) && ((_b = CS.DOM.$topBar) === null || _b === void 0 ? void 0 : _b.length)) {
                                if (((_c = CS.DOM.$subTop) === null || _c === void 0 ? void 0 : _c.length) &&
                                    ((_d = CS.CommonData.Current) === null || _d === void 0 ? void 0 : _d.Navigation.WallType) ==
                                        CS.Enumeration.WallType.MainSearch) {
                                    CS.DOM.$subTop.removeClass("sticky");
                                    CS.DOM.$subTop.css({
                                        position: "static !important",
                                    });
                                }
                                let topHeight = CS.DOM.$topBar.outerHeight();
                                $filtersBar.css("top", topHeight - 1);
                                const $tabMenu = $(".main-search-events-tab-menu-container");
                                if ($tabMenu.length) {
                                    topHeight += $filtersBar.outerHeight() - 1;
                                    $tabMenu.css("top", topHeight - 1);
                                    $tabMenu.css("position", "sticky");
                                    $tabMenu.css("z-index", "17");
                                }
                            }
                        }
                    }
                    WallSections.FilteredSection = FilteredSection;
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=filtered-section.pre.js.map
